// extracted by mini-css-extract-plugin
export default {"btn":"modal_btn__ax2BP","btn-search":"modal_btn-search__WvSBX","select":"modal_select__q8Q79","input":"modal_input__F06sW"};